<ng-container>
  <div class="edit-control-block" [hidden]="!isReadyToShow" style="min-height:34px">
    <ng-content select="[begin]"></ng-content>
    <span [hidden]="!btnExpand.isShow()" class="ml-1">
      <app-vis-button [icon]="'fullscreen'" [label]="'展開'" 
        (click)="onBtnExpandClick()" [disabled]="!btnExpand.isEnable"></app-vis-button>
    </span>
    <span [hidden]="!btnShrink.isShow()" class="ml-1">
      <app-vis-button [icon]="'fullscreen_exit'" [label]="'縮小'" 
        (click)="onBtnShrinkClick()" [disabled]="!btnShrink.isEnable"></app-vis-button>
    </span>
    <span [hidden]="!btnClear.isShow()" class="ml-1">
      <app-vis-button [icon]="'remove_circle'" [iconCls]="'remove'" [label]="'清除'" 
        (click)="onBtnClearClick()" [disabled]="!btnClear.isEnable"></app-vis-button>
    </span>
    <span [hidden]="!btnEdit.isShow()" class="ml-1">
      <app-vis-button *appAllowPermissionIf="[UserPermissions.Modify]" [icon]="'edit'" [iconCls]="'add'" [label]="'編輯'"
          (click)="onBtnEditClick()" [disabled]="!btnEdit.isEnable || disableEditButton"></app-vis-button>
    </span>
    <span [hidden]="!btnAdd.isShow()" class="ml-1">
      <app-vis-button *appAllowPermissionIf="[UserPermissions.Add]" [icon]="'add_circle'" [iconCls]="'add'" [label]="'新增'" 
        (click)="onBtnAddClick()" [disabled]="!btnAdd.isEnable"></app-vis-button>
    </span>
    <span [hidden]="!btnDelete.isShow()" class="ml-1">
      <app-vis-button *appAllowPermissionIf="[UserPermissions.Delete]" [icon]="deleteIcon" [iconCls]="'remove'" [label]="deleteWords" 
        (click)="onBtnDeleteClick()" [disabled]="!btnDelete.isEnable"></app-vis-button>
    </span>
    <span [hidden]="!btnCancel.isShow()" class="ml-1">
      <app-vis-button [icon]="'clear'" [iconCls]="'remove'" [label]="'取消'" 
        (click)="onBtnCancelClick()" [disabled]="!btnCancel.isEnable"></app-vis-button>
    </span>
    <span [hidden]="!btnSave.isShow()" class="ml-1">
      <app-vis-button [icon]="'save'" [iconCls]="'add'" [label]="'儲存'" 
        (click)="onBtnSaveClick()" *appAllowPermissionIf="[[UserPermissions.Modify, UserPermissions.Add]]" [disabled]="!btnSave.isEnable"></app-vis-button>
    </span>
    <span [hidden]="!btnFinish.isShow()" class="ml-1">
      <app-vis-button [icon]="'done'" [iconCls]="'add'" [label]="'完成'" 
        (click)="onBtnFinishClick()" [disabled]="!btnFinish.isEnable"></app-vis-button>
    </span>
    <ng-content select="[end]"></ng-content>
  </div>
  <div class="clearfix"></div>
</ng-container>
<app-shared-delete-dialog [isDialogOpened]="isDeleteDialogOpened" (emitResult)="onDeleteDialogResult($event)">
</app-shared-delete-dialog>
